// src/App.js
import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import PostList from "./pages/PostList";
import PostDetail from "./pages/PostDetail";
import PostCreate from "./pages/PostCreate";
import PostEdit from "./pages/PostEdit";
import PostCategory from "./pages/PostCategory";
import Login from "./pages/Login";
import Register from './pages/Register';
import Profile from "./pages/Profile";
import TaskPage from "./pages/TaskPage";
import BoardsPage from "./pages/BoardsPage";
import AnsiblePage from "./pages/Ansible";
import Layout from "./components/Layout/Layout";

import { AuthProvider, useAuth } from "./context/AuthContext";
import authApi from "./api/authApi";
import { attachAuthInterceptors } from "./api/attachInterceptors";

function AppContent() {
  const { logout } = useAuth();

  useEffect(() => {
    attachAuthInterceptors(authApi, logout); // ✅ axios 인터셉터에 logout 연결
  }, [logout]);

  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/posts" element={<PostList />} />
            <Route path="/posts/:id" element={<PostDetail />} />
            <Route path="/postCreate" element={<PostCreate />} />
            <Route path="/posts/:id/edit" element={<PostEdit />} />
            <Route path="/post/:category" element={<PostCategory />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/tasks" element={<TaskPage />} />
            <Route path="/boards" element={<BoardsPage />} />
            <Route path="/ansible" element={<AnsiblePage />} />
          </Routes>
        </Layout>
        <Footer />
      </div>
    </Router>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent /> {/* ✅ useAuth는 이 내부에서만 사용 가능 */}
    </AuthProvider>
  );
}

export default App;
